import React, { Component, PropTypes } from 'react';
import NetworkServiceDialog from './network-service-dialog';
import { lang } from '../../strings';

export default class NetworkServices extends Component {

   constructor(props) {
      super(props);

      this.state = this.makeInitialState(props);
   }

   makeInitialState(props) {
      return {
         showDialog: false,
         currentNetworkService: null
      };
   }

   render() {
      let { networkServices } = this.props;
      let { showDialog, currentNetworkService } = this.state;

      return (
         <div className="mp-tile">
            <h2 className="h5 color-dark-blue">{lang.networkServices.title}</h2>
            <table className="mp-table">
               <tbody>
               {networkServices.map(service => {
                  let id = 'service' + service.id;
                  return (
                     <tr key={service.id}>
                        <td>{service.description}</td>
                        <td>
                           <div style={{float: 'right'}}>
                              <input id={id} className="mp-toggle mp-toggle-light" type="checkbox" checked={service.enabled} disabled={service.disabled} onChange={ev => this.confirmChangeNetworkService(ev, service)} />
                              <label htmlFor={id} className="mp-toggle-btn"/>
                           </div>
                        </td>
                     </tr>
                  );
                  }
               )}
               </tbody>
            </table>
            {showDialog ? <NetworkServiceDialog networkService={currentNetworkService} onConfirm={this.changeNetworkService} onCancel={this.hideDialog} /> : null}
         </div>
      )
   }

   changeNetworkService = ev => {
      ev.preventDefault();
      let service = this.state.currentNetworkService;
      service.enabled = !service.enabled;
      this.props.changeNetworkService(service);
      this.setState({ showDialog: false });
   };

   confirmChangeNetworkService = (ev, service) => {
      ev.preventDefault();
      this.setState({
         currentNetworkService: service,
         showDialog: true
      });
   };

   hideDialog = ev => {
      ev.preventDefault();
      this.setState({ showDialog: false });
   };
}

NetworkServices.propTypes = {
   networkServices: PropTypes.array.isRequired,
   changeNetworkService: PropTypes.func.isRequired
};